import React, { useContext, useEffect, useState } from "react";

import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";
import Send from "@material-ui/icons/Send";
import Button from "@material-ui/core/Button";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

import Swal from "sweetalert2";

import { sendEmailCNDAgendaCliente } from "../../../repository/ERP/pub/CNDAgendaClienteService";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import Loading from "../../../components/basics/Loading";
import TabsErp from "../../../components/tabs/TabsErp";
import { notify } from "../../../utils/notify";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import "../CND.css";

export default function CNDSendEmail({
  openSendEmail = false,
  setOpenSendEmail,
  files,
  email,
}) {
  const [emails, setEmails] = useState([""]);
  const [loading, setLoading] = useState(false);

  const { queryParams } = useContext(QueryParamsContext);

  useEffect(() => {
    setEmails([email && typeof email === "string" ? email.toLowerCase() : ""]);
  }, [openSendEmail, email]);

  const handleCancel = () => {
    setOpenSendEmail(false);
  };

  const handleClose = () => {
    setOpenSendEmail(false);
  };

  const handleAdd = () => {
    if (emails.length < 5) {
      setEmails([...emails, ""]);
    }
  };

  const handleRemove = (index) => {
    const copy = [...emails];
    copy.splice(index, 1);
    setEmails(copy);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      setLoading(true);

      if (!files || !Array.isArray(files) || files.length < 1) {
        return setLoading(false);
      }

      const arrFiles = [];
      files.forEach((file, index) => {
        if (file) {
          arrFiles.push({
            data: file.substring(
              file.split("").findIndex((e) => e === ",") + 1
            ),
            filename: `CND-${index}.${file.substring(
              file.split("").findIndex((e) => e === "/") + 1,
              file.split("").findIndex((e) => e === ";")
            )}`,
          });
        }
      });

      if (arrFiles.length < 1) {
        return notify(
          "As CNDs selecionadas não respeitam as configurações de envio."
        );
      }

      const result = await sendEmailCNDAgendaCliente({
        from: { name: null },
        e_mails: emails,
        e_mailsCC: [],
        attachment: arrFiles,
        subject: "QYON - ERP  Controle de CNDs",
        replyTo: "",
        bodyHtml: `<h3>Prezado cliente,</h3><br/>Segue anexa certidão emitida para sua empresa.<br/>Nos colocamos à disposição para maiores esclarecimentos.<br/><br/><br/>Atenciosamente,<br/>${
          queryParams.apelido || ""
        }`,
      });

      if (result && result.success) {
        setOpenSendEmail(false);
        return Swal.fire({
          icon: "success",
          text: "E-mail enviado com sucesso.",
          showConfirmButton: true,
          timer: 3000,
        });
      }

      return Swal.fire({
        icon: "error",
        text: "Falha ao enviar e-mail.",
        showConfirmButton: true,
        timer: 3000,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Falha ao enviar e-mail.",
        showConfirmButton: true,
        timer: 3000,
      });

      console.error("ERROR CNDSendEmail handleSubmit", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loading open={loading} />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal"
        open={openSendEmail}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openSendEmail}>
          <form onSubmit={handleSubmit} className="form-send-email">
            <TabsErp
              headers={[
                {
                  label: "Envio",
                },
              ]}
              children={[]}
              tabIndex={0}
            />
            <Grid className="grid-container-send-email">
              {emails.map((email, index) => (
                <Grid container spacing={1} key={index}>
                  <Grid item xs={6} md={10} lg={10}>
                    <TextFieldErp
                      type="email"
                      required
                      label={`${index + 1}º Email`}
                      lg={2}
                      value={emails[index]}
                      setValue={(value) => {
                        const copy = [...emails];
                        copy[index] = value.toLowerCase();
                        setEmails(copy);
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={2} lg={2} className="margin-top-5">
                    {index === emails.length - 1 && emails.length < 5 && (
                      <AddCircleIcon
                        onClick={handleAdd}
                        className="icon-modal-send-email"
                      />
                    )}

                    {index !== 0 && (
                      <RemoveCircleIcon
                        onClick={() => handleRemove(index)}
                        className="icon-modal-send-email"
                      />
                    )}
                  </Grid>
                </Grid>
              ))}

              <Grid
                item
                md={12}
                container
                justify="flex-end"
                className="cnd-container-btns"
              >
                <Button
                  variant="contained"
                  startIcon={<KeyboardReturnIcon />}
                  className="cnd-btn-cancelar"
                  onClick={handleCancel}
                >
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Send />}
                  type="submit"
                >
                  Enviar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Fade>
      </Modal>
    </>
  );
}
